import { default as routes } from './routes';
import { default as labels } from './labels';

export default {
    ...routes,
    ...labels
};
